module.exports = __webpack_public_path__ + "static/media/10.23884ef4.mp3";